import debounce from 'debounce';
import * as R from 'ramda';
import agendaTimelineAnimation from './agendaTimelineAnimation';

const SCROLL_OFFSET = 120;


export const moduleSetup = (type, setupFn, windowFn = window) => R.pipe(
	R.prop('_moduleJs'),
	R.defaultTo([]),
	R.filter(
		R.propEq('type', type)
	),
	R.forEach(setupFn)
)(windowFn)

const scrollTop = () => window._views.scrollTo(0);

const getYPos = element => (
	window.scrollY + element.getBoundingClientRect().top
);


export function timelineSetup(element) {
	let filteredElements = [];
	let filteredTops = [];

	const wrapperElement = document.getElementById(element.id);

	const getModuleElements = selector => document.querySelectorAll(
		`#${element.id} ${selector}`
	);

	const $el = jQuery(`#${element.id}`);
	const find$El = selector => $el.find(selector);
	let searchText = '';

	const searchElement = getModuleElements('.evtx-agenda-search')[0];
	const sessionElements = getModuleElements('.evtx-session');
	const clearFiltersElement = getModuleElements('.evtx-clear-filters')?.[0];

	const filterElements = (predicate) => {
		filteredElements = [];
		filteredTops = [];
		sessionElements.forEach((s) => {
			if (predicate(s)) {
				filteredElements.push(s);
				filteredTops.push( getYPos(s) );
				s.classList.remove('inactive');
			}
			else {
				s.classList.add('inactive');
			}
		})
		getModuleElements('.evtx-time-group')
			.forEach((el) => {
				const sessions = Array.from(el.querySelectorAll('.evtx-session'));
				if (sessions.every(s => s.classList.contains('inactive'))) {
					el.classList.add('inactive');
				}
				else {
					el.classList.remove('inactive');
				}
			})

		const noneFoundEl = document.getElementById('none-found');
		if (!filteredElements.length) {
			noneFoundEl.classList.remove('invisible')
		}
		else {
			if (!noneFoundEl.classList.contains('invisible')) {
				noneFoundEl.classList.add('invisible');

			}
		}
		getModuleElements('.timeline-container')
			.forEach(el => el.classList.add('invisible'));
		filtersUpdated();
	}

	// search filter
	searchElement.addEventListener('keyup', function(e) {
		const needle = e.target.value.toLowerCase();
		freeTextSearch(needle);
	});

	const freeTextSearch = debounce(needle => {
		if (needle === searchText) {
			return;
		}
		searchText = needle;

		if (!needle) {
			clearFilters();
			return;
		}
		filterElements(s => {
			const haystack = s.innerHTML.toLowerCase();
			return haystack.indexOf(needle) >= 0;
		});
	}, 300);

	

	function clearFilters() {
		getModuleElements('.inactive').forEach(
			el => el.classList.remove('inactive')
		)
		searchText = '';
		searchElement.value = ''
		filtersUpdated(false);
		window._views.scrollTo(
			getYPos(wrapperElement) - SCROLL_OFFSET
		);
		const noneFoundEl = document.getElementById('none-found');
		getModuleElements('.timeline-container')
			.forEach(el => el.classList.remove('invisible'));
		noneFoundEl.classList.add('invisible');
	}

	// Clear filters on button click
	// clearFiltersElement.addEventListener('click', clearFilters);
	jQuery('.evtx-clear-filters').on('click', clearFilters);

	// Clear filters on escape
	document.addEventListener('keydown', function(e) {
		if (e.code === 'Escape') {
			clearFilters();
		}
	})

	function filtersUpdated(filtersActive = true, invisibleClass = 'invisible') {
		
		// update visibility of clear filters button
		if (filtersActive) {
			jQuery('.evtx-clear-filters').removeClass(invisibleClass);
		}
		else {
			jQuery('.evtx-clear-filters').addClass(invisibleClass);
		}
		window._views.scrollTo(0);
		// filteredTops.sort((a, b) => a - b);
		// if (filteredTops[0]) {
		// 	window._views.scrollTo(filteredTops[0] - SCROLL_OFFSET);
		// }
	}

/* 
	const trackFilterElements = getModuleElements('.btn-track-filter');
	trackFilterElements.forEach(el => {
		const t = el.getAttribute('data-track').toLowerCase();
		el.addEventListener('click', () => {
			trackFilterElements.forEach(t => {
				if (t === el) {
					t.classList.remove('inactive')
				}
				else {
					t.classList.add('inactive');
				}
			});
			filterElements(s => ( 
				s.getAttribute('data-tracks')
					.toLowerCase()
					.split(', ')
					.includes(t)
			));
		});
	})
	const keywordFilterElements = getModuleElements('.btn-keyword-filter');
	keywordFilterElements.forEach(el => {
		const t = el.getAttribute('data-keyword').toLowerCase();
		el.addEventListener('click', () => {
			keywordFilterElements.forEach(t => {
				if (t === el) {
					t.classList.remove('inactive')
				}
				else {
					t.classList.add('inactive');
				}
			});
			filterElements(s => ( 
				s.getAttribute('data-keywords')
					.toLowerCase()
					.split(', ')
					.includes(t)
			));
		});
	}) */
	const filterBtns = getModuleElements('.btn-filter');
	filterBtns.forEach(el => {
		const isKeywordFilter = el.classList.contains('btn-keyword-filter');
		const needle = el.getAttribute(
			isKeywordFilter
				? 'data-keyword'
				: 'data-track'
		)
		el.addEventListener('click', () => {
			// toggle state of button
			filterBtns.forEach(b => {
				if (b === el) {
					b.classList.remove('inactive')
				}
				else {
					b.classList.add('inactive');
				}
			});
			filterElements(s => ( 
				s.getAttribute(isKeywordFilter
					? 'data-keywords'	
					: 'data-tracks'
				)
					.toLowerCase()
					.split(', ')
					.includes(needle.toLowerCase())
			));
		});
	})

	
	if (element.options.timeline) {
		agendaTimelineAnimation(
			getModuleElements('.evtx-time-group'),
			element.data.date_info
		);
	}


}

moduleSetup('AGENDA_TIMELINE', timelineSetup);